export default __webpack_public_path__ + "static/media/VenueIcon.e206fee8.svg";